import React, { Component } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./slick.css";
import { styled } from "styled-components";

const settings = {
  dots: true,
  infinite: true,
  arrow: false,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
};

const MobileCarousel = ({ images }) => {
  return (
    <SliderContainer>
      <Slider {...settings}>
        {images?.map((item) => (
          <SliderImageContainer>
            <SliderImage src={item.url} alt={item.alt} />
          </SliderImageContainer>
        ))}
      </Slider>
    </SliderContainer>
  );
};

const SliderContainer = styled.div`
  display: none;
  @media only screen and (max-width: 1024px) {
    display: block;
  }
`;
const SliderImageContainer = styled.div``;
const SliderImage = styled.img`
  height: 15rem;
  object-fit: cover;
  width: 100%;
`;

export default MobileCarousel;
